// PDPA cookie consent state (persisted via vuex-persistedstate -> localStorage)

// เพิ่มเลขเวอร์ชันเมื่อนโยบายคุกกี้เปลี่ยน เพื่อบังคับให้ผู้ใช้ยินยอมใหม่
const POLICY_VERSION = "1.0";

// ค่าเริ่มต้นของแต่ละหมวด: หมวดที่ไม่จำเป็นต้องเป็น false (opt-in) ตาม PDPA
const defaultCategories = () => ({
  necessary: true, // จำเป็น เปิดเสมอ ปิดไม่ได้
  analytics: false,
  marketing: false,
  functionality: false,
  targeting: false,
});

const Consent = {
  name: "Consent",
  stateFactory: true,
  namespaced: true,
  state: {
    decided: false, // ผู้ใช้ตัดสินใจไปแล้วหรือยัง
    categories: defaultCategories(),
    consentDate: null, // เวลาที่ให้ความยินยอม (ISO string) สำหรับเก็บหลักฐาน
    policyVersion: null, // เวอร์ชันนโยบายที่ผู้ใช้ยินยอม
  },
  getters: {
    // ต้องแสดงแถบขอความยินยอมเมื่อยังไม่ตัดสินใจ หรือเวอร์ชันนโยบายเปลี่ยน
    needsConsent: (state) =>
      !state.decided || state.policyVersion !== POLICY_VERSION,
    isAllowed: (state) => (category) => !!state.categories[category],
  },
  mutations: {
    SET_CONSENT: (state, categories) => {
      state.categories = {
        ...defaultCategories(),
        ...categories,
        necessary: true,
      };
      state.decided = true;
      state.consentDate = new Date().toISOString();
      state.policyVersion = POLICY_VERSION;
    },
    RESET_CONSENT: (state) => {
      state.decided = false;
      state.categories = defaultCategories();
      state.consentDate = null;
      state.policyVersion = null;
    },
  },
  actions: {
    // ยอมรับทั้งหมด
    acceptAll({ commit }) {
      commit("SET_CONSENT", {
        analytics: true,
        marketing: true,
        functionality: true,
        targeting: true,
      });
    },
    // ปฏิเสธทั้งหมด (เหลือเฉพาะคุกกี้ที่จำเป็น)
    rejectAll({ commit }) {
      commit("SET_CONSENT", {
        analytics: false,
        marketing: false,
        functionality: false,
        targeting: false,
      });
    },
    // บันทึกตามที่ผู้ใช้เลือกในหน้าตั้งค่า
    savePreferences({ commit }, categories) {
      commit("SET_CONSENT", categories);
    },
  },
};

export default Consent;
